// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70724321","455":"b921e9ac","977":"4fc70ece"}[chunkId] + ".chunk.js";
};